import React from "react"
import { graphql, StaticQuery } from "gatsby"

const AppleShareIconView: React.FC<{ imageFromQuery: any; width: number }> = ({
  imageFromQuery,
  width,
}) => {
  return (
    <img
      className="p-0 m-0 block-inline"
      src={imageFromQuery.icon.publicURL}
      width={width}
    />
  )
}

const AppleShareIcon: React.FC<{ width: number }> = ({ width }) => {
  const gqlFetchQuery = graphql`
    query {
      icon: file(relativePath: { eq: "apple-share-icon.svg" }) {
        publicURL
      }
    }
  `
  return (
    <StaticQuery query={gqlFetchQuery}>
      {data => <AppleShareIconView imageFromQuery={data} width={width} />}
    </StaticQuery>
  )
}

export default AppleShareIcon
